<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  categories: Array,
  firstData: Array,
  secondData: Array,
})

onMounted(() => {
  const { categories, firstData, secondData } = props

  $("#compareSchoolsCS").dataTable({
    bPaginate: false,
    bInfo: false,
    order: [[4, "desc"]],
    aoColumnDefs: [
      { sType: "html", aTargets: [0] },
      { sType: "title-numeric", aTargets: [3] },
      { sType: "title-numeric", aTargets: [6] },
      { sType: "title-numeric", aTargets: [9] },
      { asSorting: ["asc", "desc"], aTargets: [0] },
      { asSorting: ["desc", "asc"], aTargets: ["_all"] },
    ],
    oLanguage: {
      sSearch: "Filter schools:",
    },
  })

  Highcharts.chart("cs_table", {
    chart: {
      zoomType: "xy",
    },
    title: {
      text: "Conditional Scholarship Trends",
    },
    xAxis: [{
      categories,
      crosshair: true,
    }],
    yAxis: [{ // Primary yAxis
      labels: {
        format: "{value}%",
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
      title: {
        text: "",
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
    }],
    tooltip: {
      shared: true,
      formatter() {
        let s = `<b>${this.x} - ${this.x + 1} Academic Year</b>`
        let n = 0
        $.each(this.points, function () {
          s += `<br/>${Math.round(this.y * 100) / 100}%`

          if (n == 0) {
            s += " of schools had conditional scholarships"
          } else {
            s += " of students with a conditional scholarship lost scholarship value"
          }
          n++
        })

        return s
      },
    },
    legend: {
      enabled: false,
      layout: "vertical",
      align: "left",
      x: 150,
      verticalAlign: "top",
      y: 150,
      floating: true,
      backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || "#FFFFFF",
    },
    series: [
      {
        name: "",
        color: Highcharts.getOptions().colors[4],
        data: firstData,
        marker: { enabled: false, symbol: "circle" },
        type: "spline",
      },
      {
        name: "",
        color: Highcharts.getOptions().colors[6],
        data: secondData,
        marker: { enabled: false, symbol: "circle" },
        type: "spline",
      },
    ],
  })
})
</script>
